import { JobStatus, SupabaseJob } from '@applicator/shared'

const DEFAULT_STATUS_BADGE_CLASSES = 'bg-surface-muted text-text-secondary'
const BADGE_BASE_CLASSES = 'px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap flex-shrink-0'

export function getStatusBadgeClasses(status: JobStatus): string {
  const statusClasses: Record<JobStatus, string> = {
    'Bookmarked': DEFAULT_STATUS_BADGE_CLASSES,
    'Applying': 'bg-info-subtle text-info',
    'Applied': 'bg-brand-primary-subtle text-brand-primary',
    'Interviewing': 'bg-warning-subtle text-warning',
    'Negotiating': 'bg-warning-subtle text-warning',
    'Accepted': 'bg-brand-primary-subtle text-brand-primary-strong',
    'I Withdrew': 'bg-danger-subtle text-danger-strong',
    'Not Selected': 'bg-danger-subtle text-danger-strong',
    'No Response': DEFAULT_STATUS_BADGE_CLASSES,
    'Archived': 'bg-surface-muted text-text-muted',
  }
  return statusClasses[status] || DEFAULT_STATUS_BADGE_CLASSES
}

export function getStatusDisplayText(status: JobStatus): string {
  return status === 'No Response' ? 'No Response 👻' : status
}

export function shouldShowRelevanceBadge(supabaseJob?: SupabaseJob): boolean {
  if (!supabaseJob) return false
  return supabaseJob.is_relevant === true || supabaseJob.is_relevant === false
}

function isJobRelevant(supabaseJob?: SupabaseJob): boolean {
  return supabaseJob?.is_relevant === true
}

function isJobNotRelevant(supabaseJob?: SupabaseJob): boolean {
  return supabaseJob?.is_relevant === false
}

export function getRelevanceBadgeClasses(supabaseJob?: SupabaseJob): string {
  const isRelevant = isJobRelevant(supabaseJob)
  const isNotRelevant = isJobNotRelevant(supabaseJob)
  if (isRelevant) return `${BADGE_BASE_CLASSES} bg-brand-primary-subtle text-brand-primary-strong`
  if (isNotRelevant) return `${BADGE_BASE_CLASSES} bg-danger-subtle text-danger-strong`
  return `${BADGE_BASE_CLASSES} bg-warning-subtle text-warning`
}

export function getRelevanceBadgeText(supabaseJob?: SupabaseJob): string {
  const isRelevant = isJobRelevant(supabaseJob)
  const isNotRelevant = isJobNotRelevant(supabaseJob)
  if (isRelevant) return '✓ Relevant'
  if (isNotRelevant) return '✗ Not Relevant'
  return 'Analyzing...'
}
